import { render, staticRenderFns } from "./AssistantsIcon.vue?vue&type=template&id=eb19b44c&"
import script from "./AssistantsIcon.vue?vue&type=script&lang=js&"
export * from "./AssistantsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports